import { render } from "./entity-notification-view.vue?vue&type=template&id=99c726ea&lang=html"
import script from "./entity-notification-view.vue?vue&type=script&lang=js"
export * from "./entity-notification-view.vue?vue&type=script&lang=js"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__